//'use strict';


var additionalRequirementsForModule = [ 'ui.bootstrap' ];
Array.prototype.push.apply(bookModule.requires, additionalRequirementsForModule);


bookModule.controller('curriculumControllerAH16', 
    ['$scope', '$controller', 'getChapterConfig', '$location', '$state', '$document', '$uibModal',
    function ($scope, $controller, getChapterConfig, $location, $state, $document, $uibModal) {
        // Initialize the parent class and extend it.
        angular.extend(this, $controller('curriculumController', {$scope: $scope}) );
        var vm = $scope.ctrl;

        vm.getOpenCoreSkillContentNode = function() {
            if (vm.openSkillIndex == undefined) return undefined;
            var openDomainNode = vm.getOpenDomainContentNode();
            if (openDomainNode == undefined) return undefined;
            // AH Hack - here we will default the index to 0 as there is always one CoreSkill
            var skillContentNode = openDomainNode.children[ 0 ];
            return skillContentNode;
        };

        vm.getOpenOutcomeContentNode = function() {
            if (vm.openOutcomeIndex == undefined) return undefined;
            var openCoreSkillNode = vm.getOpenCoreSkillContentNode();
            if (openCoreSkillNode == undefined) return undefined;
            // AH Hack - we can't use the index so instead we will match the chapter upto the outcome ie: AHX.X.X                 
            var outcomeContentNodeIndex = undefined;
            var expectedOutcomeChapterString = vm.chapterString.split('.').slice(0, 3).join('.');
            openCoreSkillNode.children.some( function ( obj, index )
            {
                var isObjMatchingExpectedOutcomeChapter = vm.chapterString.match(new RegExp(obj.chapter, 'gi'));                        
                if ( isObjMatchingExpectedOutcomeChapter )
                {
                    outcomeContentNodeIndex = index;
                    return true;
                }
            } );
            var outcomeContentNode = outcomeContentNodeIndex !== undefined ? openCoreSkillNode.children[outcomeContentNodeIndex] : undefined;
            return outcomeContentNode;
        };
    } ]
);